'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dEnvelopes$002dPage$0024 from "./presto.-List-Envelopes-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103 from "./presto.-Presto-Router$$anon$103.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$102() {
  this.bde = null;
  this.bd6 = null;
  this.bd7 = false;
  this.bdf = null;
  this.bdg = false;
  this.bdj = null;
  this.bdc = null;
  this.bdd = false;
  this.bd8 = null;
  this.bd9 = false;
  this.bda = null;
  this.bdb = false;
  this.bdh = false;
  this.bdi = false;
  this.bde = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdj = "ListEnvelopesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$102 as $c_Lpresto_PrestoRouter$$anon$102 };
$p = $c_Lpresto_PrestoRouter$$anon$102.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$102;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$102() {
}
export { $h_Lpresto_PrestoRouter$$anon$102 as $h_Lpresto_PrestoRouter$$anon$102 };
$h_Lpresto_PrestoRouter$$anon$102.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bde;
});
$p.L = (function() {
  if ((!this.bd7)) {
    this.bd6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bd7 = true;
  }
  return this.bd6;
});
$p.O = (function() {
  if ((!this.bdg)) {
    this.bdf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdg = true;
  }
  return this.bdf;
});
$p.E = (function() {
  return this.bdj;
});
$p.t = (function() {
  if ((!this.bdd)) {
    this.bdc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bdd = true;
  }
  return this.bdc;
});
$p.M = (function() {
  if ((!this.bd9)) {
    this.bd8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bd9 = true;
  }
  return this.bd8;
});
$p.Q = (function() {
  if ((!this.bdb)) {
    this.bda = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103.$c_Lpresto_PrestoRouter$$anon$103();
    this.bdb = true;
  }
  return this.bda;
});
$p.w = (function() {
  if ((!this.bdi)) {
    this.bdh = false;
    this.bdi = true;
  }
  return this.bdh;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee618) => ((p) => \u03b4scrutinee618))($j_presto$002e$002dList$002dEnvelopes$002dPage$0024.$m_Lpresto_ListEnvelopesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$102 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$102, "presto.PrestoRouter$$anon$102", ({
  Np: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$102 as $d_Lpresto_PrestoRouter$$anon$102 };
//# sourceMappingURL=presto.-Presto-Router$$anon$102.js.map
